import React from 'react';

const VolunteerDetail = () => {
    return (
        <div className='mt-5 mx-2'>
            <h2 className="card-title text-[#F7941D] text-center justify-center">Volunteer Details</h2>
            <hr className="h-px my-2 mx-16 bg-[#F7941D]"></hr>
            <div className=''>
                <div>
                    <h1>Which division are you from?</h1>
                </div>
                <div>
                    <h1>Which district are you from?</h1>
                </div>
                <div>
                    <h1>What is your contact address?</h1>
                </div>
                <div>
                    <h1>Your Full Name :</h1>
                </div>
                <div>
                    <h1>Your Email Address :</h1>
                </div>
                <div>
                    <h1>Your Phone Number :</h1>
                </div>
                <div>
                    <h1>Date of birth :</h1>
                </div>
                <div>
                    <h1>Your Gender :</h1>
                </div>

                <div>
                    <h1>Your Blood Group :</h1>
                </div>
                <div>
                    <h1>What is your T-Shirt size?</h1>
                </div>
                <div>
                    <h1>What is your Profession?</h1>
                </div>
                <div>
                    <h1>Highest level of education?</h1>
                </div>
                <div>
                    <h1>Your Current Educational Institute(If)?</h1>
                </div>
                <div>
                    <h1>Do you have any experience in social work?</h1>
                </div>
                <div>
                    <h1>Which day you are available for Volunteerism?</h1>
                </div>
                <div>
                    <h1>Emergency Contact Person Name??</h1>
                </div>

                <div>
                    <h1>Contact Person Phone Number?</h1>
                </div>
                <div>
                    <h1>Relationship with you?</h1>
                </div>
            </div>
            <div className='my-4'>
                <button className='rounded-md py-2 px-5 bg-[#F7941D] text-white'>Approved</button>
                <button className='ml-3 rounded-md py-2 px-5 bg-[#ED6B75] text-white'>Delete</button>
            </div>
        </div>
    );
};

export default VolunteerDetail;